import React, { useState, useContext, useRef } from "react";
import { NavLink } from "react-router-dom";
import Moment from "react-moment";
import moment from 'moment';

//pages & includes
import AccountsSidebar from "../AccountsSidebar";
import ViewAccountSheet from "./ViewAccountSheet";
//functions
import {
  _t,
  getCookie,
  tableLoading,
  pagination,
  paginationLoading,
  showingData,
  searchedShowingData,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { MdDelete } from 'react-icons/md';
import { useReactToPrint } from "react-to-print";
import AccountPrint from "./AccountPrint";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";


//context consumer
import { FinanceContext } from "../../../../../contexts/Finance";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const OpeningAccount = () => {
  const { t } = useTranslation();
    //getting context values here
    
    //finance context
    const {
      loading,
      setLoading,

      //OAList
      openingAccountList,
      setOpeningAccountList,
      openingAccountListForSearch,
      setOpeningAccountListForSearch,
      setPaginatedOAList,

      //pagination
      dataPaginating,
      setDataPaginating
    } = useContext(FinanceContext);
    
    //search result
    let [searchedOAList, setSearchedOAList] = useState({
      list: null,
      searched: false,
    });

    const [accountLedger,setAccountLedger]=useState({
      modal:false,
      ledger:null,
    });
  
    //delete account here
    const handleDeleteAccount = (slug) => {
      setDataPaginating(true);
      const bplUrl = BASE_URL + `/settings/delete-opening-account/${slug}`;
      return axios
        .get(bplUrl, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setOpeningAccountList(res.data[0]);
          setOpeningAccountListForSearch(res.data[1]);
          setSearchedOAList({
            ...searchedOAList,
            list: res.data[1],
          });
          setDataPaginating(false);
          toast.success(`${_t(t("Account has been deleted successfully"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        })
        .catch(() => {
          setDataPaginating(false);
          toast.error(`${_t(t("Please try again"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        });
    };

    //search account here
    const handleSearch = (e) => {
      let searchInput = e.target.value.toLowerCase();
      if (searchInput.length === 0) {
        setSearchedOAList({ ...searchedOAList, searched: false });
      } else {
        let searchedList = openingAccountListForSearch.filter((item) => {          
          let lowerCaseItemIdentity = item.document_identity.toLowerCase();
          let lowerCaseItemRemarks = item?.remarks && item.remarks.toLowerCase();
          let lowerCaseItemDate = moment(item.document_date).format("LL").toLowerCase();
          return lowerCaseItemIdentity.includes(searchInput) ||
          (lowerCaseItemRemarks && lowerCaseItemRemarks.includes(searchInput)) ||
          lowerCaseItemDate.includes(searchInput);
        });
        setSearchedOAList({
          ...searchedOAList,
          list: searchedList,
          searched: true,
        });
      }
    };
  
    //delete confirmation modal of account
    const handleDeleteConfirmation = (slug) => {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="card card-body">
              <h1>{_t(t("Are you sure?"))}</h1>
              <p className="text-center">{_t(t("You want to delete this?"))}</p>
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-primary rounded"
                  onClick={() => {
                    handleDeleteAccount(slug);
                    onClose();
                  }}
                >
                  {_t(t("Yes, delete it!"))}
                </button>
                <button className="btn btn-success ml-2 px-3 rounded" onClick={onClose}>
                  {_t(t("No"))}
                </button>
              </div>
            </div>
          );
        },
      });
    };
  
    
    const componentRef = useRef("");
     //print satate
     const [bankPayment,setBankPayment]=useState({
      doc_date:new Date(),
      branch_name:"",
      doc_no: null,
      remarks:""
    });

    //Totals of rows
    const [totalDebit,setTotalDebit]=useState(0);
    const [totalCredit,setTotalCredit]=useState(0);
    const [newRow,setNewRow]=useState([]);

    const handleOnlyPrint = useReactToPrint({
      content: () => componentRef.current,
      pageStyle: "@page {margin: 20px}"
    });
  
    const handlePrint = async(item) =>{
      setDataPaginating(true);
      const url = BASE_URL + "/settings/opening-account-print/" + item;
      try {
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        // console.log("check data==>",res.data)
        const dateFormat = new Date(res.data.document_date);
        setNewRow(res.data.details)
        setBankPayment({
          doc_date: dateFormat,
          doc_no: res.data.document_identity,
          branch_name: res.data.branch_name,
          remarks: res.data.remarks
        })
        setTotalDebit(res.data.total_debit)
        setTotalCredit(res.data.total_credit);
        setTimeout(() => {
          handleOnlyPrint()
        }, 500);
        setDataPaginating(false)
      //   setDataToLocal(url, res);
      } catch (error) {
        setDataPaginating(false)
        console.log("error==>",error)
      }
    }

    const handleViewLedger = async(id) =>{
      setDataPaginating(true);
      const url = BASE_URL + "/settings/check-financial-ledger-view/" + id + "/OPA";
      try {
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        if(res.data){
          setAccountLedger({
            modal: true,
            ledger: res.data
          })
        }
        setDataPaginating(false)
      } catch (error) {
        setDataPaginating(false)
      }
    }
  
    return (
      <>
        <Helmet>
          <title>{_t(t("Opening Account"))}</title>
        </Helmet>
  
        {/* main body */}
        <main id="main" data-simplebar>
          <div className="container-fluid">
            <div className="row t-mt-10 gx-2">
              {/* left Sidebar */}
              <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
                <AccountsSidebar />
              </div>
              {/* left Sidebar ends */}
  
              {/* Rightbar contents */}
              <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
                <div className="t-bg-white">
                  <div className="fk-scroll--pos-table-menu" data-simplebar>
                    <div className="t-pl-15 t-pr-15">
                      {/* Loading effect */}
                      {/* {chartOfAccount.uploading === true || loading === true ? (
                        tableLoading()
                      ) : ( */}
                        <div key="fragment3">
                          {/* next page data spin loading */}
                          <CustomSpinLoader loading={loading || dataPaginating}/>
                          {/* spin loading ends */}
  
                          <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                            <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                              <ul className="t-list fk-breadcrumb">
                                <li className="fk-breadcrumb__list">
                                  <span className="t-link fk-breadcrumb__link text-capitalize">
                                    {!searchedOAList.searched
                                      ? _t(t("Opening Account List"))
                                      : _t(t("Search Result"))}
                                  </span>
                                </li>
                              </ul>
                            </div>
                            <div className="col-md-6 col-lg-7">
                              <div className="row gx-3 align-items-center">
                                {/* Search group */}
                                <div className="col-md-9 t-mb-15 mb-md-0">
                                  <div className="input-group">
                                    <div className="form-file">
                                      <input
                                        type="text"
                                        className="form-control border-0 form-control--light-1 rounded-left"
                                        placeholder={_t(t("Search")) + ".."}
                                        onChange={handleSearch}
                                      />
                                    </div>
                                    <button
                                      className="btn btn-primary rounded-right"
                                      type="button"
                                    >
                                      <i
                                        className="fa fa-search"
                                        aria-hidden="true"
                                      ></i>
                                    </button>
                                  </div>
                                </div>
  
                                {/* Add group modal trigger button */}
                                <div className="col-md-3 text-md-right">                                  
                                  <NavLink
                                    to="/dashboard/account/transaction/opening-account-add"
                                    className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                                  >
                                    {_t(t("add new"))}
                                  </NavLink>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* Table */}
                          <div className="table-responsive">
                            <table className="table table-bordered table-hover min-table-height">
                              <thead className="align-middle">
                                <tr>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("S/L"))}
                                  </th>
  
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Document No"))}
                                  </th>
  
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Document Date"))}
                                  </th> 

                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Branch"))}
                                  </th> 

                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Credit"))}
                                  </th> 

                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Debit"))}
                                  </th>                           

                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Remarks"))}
                                  </th>
  
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Action"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* loop here, logic === !search && haveData && haveDataLegnth > 0*/}
                                {!searchedOAList.searched
                                  ? [
                                    openingAccountList && [
                                      openingAccountList.data.length === 0 ? (
                                          <tr className="align-middle">
                                            <td
                                              scope="row"
                                              colSpan="6"
                                              className="xsm-text align-middle text-center"
                                            >
                                              {_t(t("No data available"))}
                                            </td>
                                          </tr>
                                        ) : (
                                          openingAccountList.data.map((item, index) => {
                                            return (
                                              <tr
                                                className="align-middle"
                                                key={index}
                                              >
                                                <th
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {index +
                                                    1 +
                                                    (openingAccountList.current_page -
                                                      1) *
                                                      openingAccountList.per_page}
                                                </th>
  
                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  {item.document_identity}
                                                </td>
  
                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  <Moment format="LL">
                                                    {item.document_date}
                                                  </Moment>
                                                </td>

                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  {item?.branch?.name}
                                                </td>

                                                <td className="xsm-text text-capitalize align-middle text-center" style={{maxWidth:"300px"}}>
                                                  {item.total_credit}
                                                </td>

                                                <td className="xsm-text text-capitalize align-middle text-center" style={{maxWidth:"300px"}}>
                                                  {item.total_debit}
                                                </td>
                                                  
                                                <td className="xsm-text text-capitalize align-middle text-center" style={{maxWidth:"300px"}}>
                                                  {item.remarks}
                                                </td>
  
                                                <td className="xsm-text text-capitalize align-middle text-center">                                                  
                                                  <div className="d-flex justify-content-center">                                                    
                                                    <NavLink
                                                    title="Edit"
                                                    className="btn btn-primary ml-2 rounded-sm del-btn"
                                                    to={`/dashboard/account/transaction/opening-account-edit/${item.id}`} 
                                                    >
                                                      <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
                                                    </NavLink>
                                                    <button
                                                      title="Delete"
                                                      className="btn btn-danger ml-2 rounded-sm del-btn"
                                                      onClick={()=>handleDeleteConfirmation(item.id)}                                                    
                                                    >                                                    
                                                      <MdDelete className="del-icon" />                                                    
                                                    </button> 
                                                    <button
                                                      title="Print"
                                                      className="btn btn-secondary ml-2 rounded-sm del-btn"
                                                      onClick={()=>handlePrint(item.id)}
                                                    >
                                                      <i className="fa fa-print edit-icon"></i>
                                                    </button>
                                                    <button
                                                      title="View ledger"
                                                      className="btn btn-success ml-2 rounded-sm del-btn"
                                                      onClick={() => handleViewLedger(item.id)}
                                                    >
                                                      <i className="fa fa-eye"></i>
                                                    </button>
                                                  </div>
                                                </td>                                                 
                                              </tr>
                                            );
                                          })
                                        ),
                                      ],
                                    ]
                                  : [
                                      /* searched data, logic === haveData*/
                                      searchedOAList && [
                                        searchedOAList.list.length === 0 ? (
                                          <tr className="align-middle">
                                            <td
                                              scope="row"
                                              colSpan="6"
                                              className="xsm-text align-middle text-center"
                                            >
                                              {_t(t("No data available"))}
                                            </td>
                                          </tr>
                                        ) : (
                                          searchedOAList.list.map(
                                            (item, index) => {
                                              return (
                                                <tr
                                                  className="align-middle"
                                                  key={index}
                                                >
                                                  <th
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {index +
                                                    1 +
                                                    (openingAccountList.current_page -
                                                      1) *
                                                      openingAccountList.per_page}
                                                  </th>
  
                                                  <td className="xsm-text text-capitalize align-middle text-center">
                                                    {item.document_identity}
                                                  </td>
    
                                                  <td className="xsm-text text-capitalize align-middle text-center">
                                                    <Moment format="LL">
                                                      {item.document_date}
                                                    </Moment>
                                                  </td>

                                                  <td className="xsm-text text-capitalize align-middle text-center">
                                                    {item?.branch?.name}
                                                  </td>

                                                  <td className="xsm-text text-capitalize align-middle text-center" style={{maxWidth:"300px"}}>
                                                    {item.total_credit}
                                                  </td>

                                                  <td className="xsm-text text-capitalize align-middle text-center" style={{maxWidth:"300px"}}>
                                                    {item.total_debit}
                                                  </td>
                                                    
                                                  <td className="xsm-text text-capitalize align-middle text-center" style={{maxWidth:"300px"}}>
                                                    {item.remarks}
                                                  </td>
    
                                                  <td className="xsm-text text-capitalize align-middle text-center">                                                  
                                                    <div className="d-flex justify-content-center">                                                    
                                                      <NavLink
                                                      title="Edit"
                                                      className="btn btn-primary ml-2 rounded-sm del-btn"
                                                      to={`/dashboard/account/transaction/opening-account-edit/${item.id}`}                                                      
                                                      >
                                                        <i className="fa fa-pencil" aria-hidden="true" style={{cursor: "pointer", fontSize: "1rem", color:"white"}}></i>                                                
                                                      </NavLink>
                                                      <button
                                                      title="Delete"
                                                      className="btn btn-danger btn-sm ml-2 rounded-sm"
                                                      onClick={()=>handleDeleteConfirmation(item.id)}
                                                      >
                                                      <MdDelete style={{cursor: "pointer", fontSize: "1.3rem", color:"white"}} />
                                                      </button>
                                                      <button
                                                        title="Print"
                                                        className="btn btn-secondary btn-sm ml-2 rounded-sm"
                                                        onClick={()=>handlePrint(item.id)}
                                                      >
                                                        <i className="fa fa-print"></i>
                                                      </button>
                                                      <button
                                                        title="View ledger"
                                                        className="btn btn-success ml-2 rounded-sm del-btn"
                                                        onClick={() => handleViewLedger(item.id)}
                                                      >
                                                        <i className="fa fa-eye"></i>
                                                      </button>
                                                    </div>
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )
                                        ),
                                      ],
                                    ]}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      {/* )} */}
                    </div>
                  </div>
                </div>
  
                {/* pagination loading effect */}
                { loading === true
                  ? paginationLoading()
                  : [
                      // logic === !searched
                      !searchedOAList.searched ? (
                        <div key="fragment4">
                          <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                            <div className="row align-items-center t-pl-15 t-pr-15">
                              <div className="col-md-7 t-mb-15 mb-md-0">
                                {/* pagination function */}
                                {pagination(openingAccountList, setPaginatedOAList)}
                              </div>
                              <div className="col-md-5">
                                <ul className="t-list d-flex justify-content-md-end align-items-center">
                                  <li className="t-list__item">
                                    <span className="d-inline-block sm-text">
                                      {showingData(openingAccountList)}
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        // if searched
                        <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                          <div className="row align-items-center t-pl-15 t-pr-15">
                            <div className="col-md-7 t-mb-15 mb-md-0">
                              <ul className="t-list d-flex">
                                <li className="t-list__item no-pagination-style">
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() =>
                                      setSearchedOAList({
                                        ...searchedOAList,
                                        searched: false,
                                      })
                                    }
                                  >
                                    {_t(t("Clear Search"))}
                                  </button>
                                </li>
                              </ul>
                            </div>
                            <div className="col-md-5">
                              <ul className="t-list d-flex justify-content-md-end align-items-center">
                                <li className="t-list__item">
                                  <span className="d-inline-block sm-text">
                                    {searchedShowingData(
                                      searchedOAList,
                                      openingAccountListForSearch
                                    )}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      ),
                    ]}
              </div>
              {/* Rightbar contents end*/}
            </div>
          </div>
        </main>
        {/* main body ends */}
        <AccountPrint
          name = "Opening Account"
          newRow={newRow}
          bankPayment={bankPayment}
          totalRowAmount={totalDebit}
          totalRowWhtAmount={""}
          totalRowTaxAmount={""}
          totalRowNetAmount={totalCredit}
          AccountPrint={componentRef}
        />
        <ViewAccountSheet
          accountLedger={accountLedger}
          setAccountLedger= {setAccountLedger}
        />
      </>
  )
}

export default OpeningAccount